<template>
  <base-toast :text="message"></base-toast>
  <div class="mt-3 mark-required">
    <div class="card shadow rounded-corner">
      <div class="card-body">
        <h5 class="card-title text-secondary fw-bold text-uppercase">Standard-Adresse</h5>
        <p>
          Diese Adresse wird im Bestellprozess als Rechnungsadresse vorausgewählt.
          <base-required-text></base-required-text>
        </p>
        <base-address-form
          :address="contact?.attributes"
          :errors="contact?.errors"
          :show-full-name="false"
          :show-uid="true"
          :show-phone="true"
          @update:data="changeAddressForm"
        ></base-address-form>
        <base-form-button
          label="Adresse speichern"
          :disabled="formButtonDisabled"
          :show-save-icon="true"
          @trigger-action="saveContact"
        ></base-form-button>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';

// Composeable
import useContacts from '@/composables/useContacts';

import assign from 'lodash/assign';

export default {
  setup() {
    const { contact, fetchContactByStatus, storeContact } = useContacts();
    const message = ref('');
    const formButtonDisabled = ref(false);

    const changeAddressForm = (event) => {
      contact.value.attributes[event.target.name] = event.target.value;
    };

    const saveContact = async () => {
      formButtonDisabled.value = true;
      const storedContact = await storeContact(contact.value);
      formButtonDisabled.value = false;

      // Wenn die API einen Error-Object zurückliefert, soll errors in menu gemergt werden
      if (storedContact.errors) {
        assign(contact.value, storedContact);
      } else {
        contact.value = storedContact.data;

        message.value = 'Ihre Adresse wurde erfolgreich gespeichert.';
      }
    };

    onMounted(() => {
      fetchContactByStatus('CUSTOMER');
    });

    return {
      changeAddressForm,
      contact,
      formButtonDisabled,
      message,
      saveContact,
    };
  },
};
</script>

<style lang="scss" scoped></style>
